import React, { useReducer, useEffect, useMemo, createContext, useContext, useState } from "react";
import { TourComponent0,  useInitTourSteps } from "./StepThruContext";
import { WithHelperDocs } from "./HelpMenus";

import { useTranslation } from 'react-i18next';





/**
 * @typedef {Object} TourContextType
 * @property {function} startTour - Function to start the tour.
 * @property {TourState} tourState - The current state of the tour.
 * @property {React.Dispatch<TourAction>} dispatch - Dispatch function to update the tour state.
 */
export const HomeTourContext = createContext(undefined);



export const useHomeTourContext = () => {
  const context = useContext(HomeTourContext);
  if (context === undefined) {
    throw new Error('useHomeTourContext must be used within a HomeTourContext Provider');
  }
  return context;
};



const useTOURSTEPS = () => {
  const { t, i18n } = useTranslation();
  const osteps = useMemo(() => {
    const steps = [
      {
        target: ".tour-login",
        content: t("home.tour.login"),// t("helpsupport.menu_documentation"),//
        //content:"Log in with your existing account",
        disableBeacon: true,
      },
      {
        target: ".tour-register",
        content: t("home.tour.register"),// t("helpsupport.menu_documentation"),//
        //content:"You can register an account with an email and password.",
        // disableBeacon: true,
      },
      // {
      //   target: ".tour-account-password",
      //   content: t("home.tour.password"),//t('password'),
      // },
      // {
      //   target: ".tour-login-options-fb",
      //   content: t("home.tour.facebook"),
      //     // "You can also directly login with your Facebook account",
      // },
      // {
      //   target: ".tour-login-options-google",
      //   content: t("home.tour.google"),
      //   // "You can also directly login with your Google account",
      // },
      // {
      //   target: ".tour-login-options-linkedin",
      //   content: t("home.tour.linkedin"),
      //   // "You can also directly login with your LinkedIn account",
      //   skipBeacon: false,
      // }
    ];
    return { steps };
  }, [i18n.language, i18n, t])
  return osteps;
};


function HomeHelpProvider({children}) {
  const { steps, tourState, dispatch, startTour } = useInitTourSteps(useTOURSTEPS);

  return (
      <HomeTourContext.Provider
          value={{ steps, tourState, dispatch, startTour }}
      >
          <WithHelperDocs startTour={startTour} className={[""]}>
              {children}
              <HomeTour />
          </WithHelperDocs>
      </HomeTourContext.Provider>
  )
}

function HomeTour(){
  // const = ()
  return (<TourComponent0 useTranslation={useTranslation}  useTourStepsContext={useHomeTourContext} localstoragevar="tourHome" />)
}



export { HomeHelpProvider,HomeTour };
